/**
 * =============================================================
 * AADHAV ACADEMY – TOURNAMENT EXPENSE CATEGORIES API
 * Role: Admin
 * Scope: Tournament Expense Category Master
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

/* =============================================================
   BASE ENDPOINT
============================================================= */

const TOURNAMENT_EXPENSE_CATEGORY_ENDPOINT =
  "/tournament/tournament_expense_categories.php";

/* =============================================================
   GET – Fetch Categories
============================================================= */

export const getExpenseCategories = async (
  options = {}
) => {
  try {
    const res = await apiCall(
      "GET",
      TOURNAMENT_EXPENSE_CATEGORY_ENDPOINT,
      null,
      "Expense Categories - Fetch",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message || "Failed to fetch categories",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data || [],
      count: res.count || 0,
    };

  } catch (error) {

    console.error(
      "Fetch Expense Categories Error:",
      error
    );

    return {
      success: false,
      message:
        error.message || "Unexpected error occurred",
      data: [],
    };
  }
};

/* =============================================================
   GET – Fetch Single Category
============================================================= */

export const getExpenseCategoryById = async (
  id,
  options = {}
) => {
  try {

    const res = await apiCall(
      "GET",
      `${TOURNAMENT_EXPENSE_CATEGORY_ENDPOINT}?id=${id}`,
      null,
      "Expense Category - Fetch By ID",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message || "Category not found",
      };
    }

    return {
      success: true,
      data: res.data,
    };

  } catch (error) {

    console.error(
      "Fetch Expense Category Error:",
      error
    );

    return {
      success: false,
      message:
        error.message || "Unexpected error occurred",
    };
  }
};

/* =============================================================
   POST – Create Category
============================================================= */

export const createExpenseCategory = async (
  payload,
  options = {}
) => {
  try {

    const res = await apiCall(
      "POST",
      TOURNAMENT_EXPENSE_CATEGORY_ENDPOINT,
      payload,
      "Expense Category - Create",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message || "Failed to create category",
      };
    }

    return {
      success: true,
      id: res.id,
      message: res.message,
    };

  } catch (error) {

    console.error(
      "Create Expense Category Error:",
      error
    );

    return {
      success: false,
      message:
        error.message || "Unexpected error occurred",
    };
  }
};

/* =============================================================
   POST – Update Category
============================================================= */

export const updateExpenseCategory = async (
  id,
  payload,
  options = {}
) => {
  try {

    if (!id) {
      return {
        success: false,
        message: "Invalid Category ID",
      };
    }

    const res = await apiCall(
      "POST",
      `${TOURNAMENT_EXPENSE_CATEGORY_ENDPOINT}?id=${id}`,
      payload,
      "Expense Category - Update",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message || "Failed to update category",
      };
    }

    return {
      success: true,
      message: res.message,
    };

  } catch (error) {

    console.error(
      "Update Expense Category Error:",
      error
    );

    return {
      success: false,
      message:
        error.message || "Unexpected error occurred",
    };
  }
};

/* =============================================================
   DELETE – Category
============================================================= */

export const deleteExpenseCategory = async (
  id,
  options = {}
) => {
  try {

    const res = await apiCall(
      "DELETE",
      `${TOURNAMENT_EXPENSE_CATEGORY_ENDPOINT}?id=${id}`,
      null,
      "Expense Category - Delete",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message || "Failed to delete category",
      };
    }

    return {
      success: true,
      message: res.message,
    };

  } catch (error) {

    console.error(
      "Delete Expense Category Error:",
      error
    );

    return {
      success: false,
      message:
        error.message || "Unexpected error occurred",
    };
  }
};